<svg width="10" height="16" viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M1.02109 0.266941C1.37701 -0.0889802 1.95407 -0.0889802 2.30999 0.266941L8.68255 6.63949C9.43394 7.39088 9.43393 8.60912 8.68254 9.36051L2.30999 15.7331C1.95407 16.089 1.37701 16.089 1.02109 15.7331C0.66517 15.3771 0.66517 14.8001 1.02109 14.4442L7.39364 8.07161C7.43319 8.03206 7.43319 7.96794 7.39364 7.92839L1.02109 1.55584C0.66517 1.19992 0.66517 0.622862 1.02109 0.266941Z"
  />
</svg>
